import { render, staticRenderFns } from "./NpaInitiative.vue?vue&type=template&id=7a243c1e&scoped=true"
import script from "./NpaInitiative.vue?vue&type=script&lang=js"
export * from "./NpaInitiative.vue?vue&type=script&lang=js"
import style0 from "./NpaInitiative.vue?vue&type=style&index=0&id=7a243c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a243c1e",
  null
  
)

export default component.exports